import React from 'react';
import Truncate from 'react-truncate';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import withStyles from 'react-jss';
import Favorite from './Favorite';
import InformationIcon from './InformationIcon';
import { modalOpen_GTM } from '../../gtm/datalayers/utilDataLayers.json';

const cardStyles = {
  innerContainer: (props) => ({
    borderRadius: props.innerContainerRadius,
  }),
  pictureContaner: (props) => ({
    borderRadius: props.pictureContainerRadius,
  }),
  pictureResults: (props) => ({
    borderRadius: props.pictureResultsRadius,
  }),
  subText: (props) => ({
    color: props.subTextColor,
  }),
};

function GenericCareerCard(props) {
  const {
    img,
    career,
    subText,
    favorite,
    infoIcon,
    tenant,
    location,
    subTextTriggersModal,
    alert,
    parent,
  } = {
    ...props,
  };

  const iIconStyles = {
    backgroundColor: 'transparent',
    border: 'none',
    padding: '0',
    cursor: 'pointer',
  };

  const handleInfoIconSelected = () => {
    props.history.push({
      pathname: location.pathname,
      search: location.pathname.includes('user-profile')
        ? `?userId=${props.userProfileId}&tenantId=${
            props.userProfileTenantId
          }&career=${encodeURIComponent(career.titleEn)}`
        : `?career=${encodeURIComponent(career.titleEn)}`,
      state: props.location.pathname.includes('user-profile')
        ? {
            userId: props.userProfileId,
            tenantId: props.userProfileTenantId,
          }
        : null,
    });
  };

  const renderSubTextAndInfoIcon = () => {
    if (subText && subTextTriggersModal) {
      return (
        <>
          <p
            aria-hidden
            className={['career-title-subtext', props.classes.subText].join(
              ' '
            )}
          >
            <Truncate
              lines={2}
              ellipsis="..."
              onClick={() => handleInfoIconSelected()}
            >
              {subText}
            </Truncate>
          </p>
          <button
            className="info-button"
            type="button"
            data-cy="info-button"
            style={iIconStyles}
            id={`info-${career.titleEn}${
              parent ? `-${parent}` : ''
            }-${Math.floor(Math.random() * 10000)}`}
            aria-label={`View details about ${career.titleEn} career`}
            onClick={() => handleInfoIconSelected()}
            onKeyDown={(e) => {
              if (['Enter'].includes(e.key)) handleInfoIconSelected();
            }}
          >
            <InformationIcon
              color={tenant.primary}
              gtmObj={modalOpen_GTM}
              text="information"
              section={career.titleEn}
              modalImage={img}
            />
          </button>
        </>
      );
    }
    return (
      <>
        {subText && (
          <p
            className={['career-title-subtext', props.classes.subText].join(
              ' '
            )}
          >
            <Truncate
              lines={2}
              ellipsis="..."
              onClick={() => handleInfoIconSelected()}
            >
              {subText}
            </Truncate>
          </p>
        )}
        {infoIcon && career && img && location && (
          <button
            className="info-button"
            type="button"
            data-cy="info-button"
            style={iIconStyles}
            id={`info-${career.titleEn}`}
            aria-label={`open info modal for - ${career.titleEn}`}
            onClick={() => handleInfoIconSelected()}
            onKeyDown={(e) => {
              if (['Enter'].includes(e.key)) handleInfoIconSelected();
            }}
          >
            <InformationIcon
              color={tenant.primary}
              gtmObj={modalOpen_GTM}
              text="information"
              section={career.titleEn}
              modalImage={img}
            />
          </button>
        )}
      </>
    );
  };

  return (
    <div
      id="career-card"
      className={[
        'career-card-inner-container',
        props.classes.innerContainer,
        props.overRideStyles,
      ].join(' ')}
    >
      <div
        data-cy="career-card"
        className={[
          'career-picture-container',
          props.classes.pictureContaner,
        ].join(' ')}
      >
        <img
          className={[
            'career-picture-results',
            props.classes.pictureResults,
            props.imageStyles,
          ].join(' ')}
          src={img}
          alt={`Career: ${career.titleEn}`}
        />
        {favorite && career && (
          <div className="career-card-favorite-container">
            <Favorite
              careerId={career.id}
              careerName={career.titleEn}
              career={career}
              location={props.location}
              userProfileFavorites={props.userProfileFavorites}
            />
          </div>
        )}
        <div
          className="career-content flex-column"
          style={{ display: props.hideCareerContent ? 'none' : 'visible' }}
        >
          {alert ? (
            <p
              className="career-title-results"
              role="alert"
              aria-live="assertive"
              aria-atomic="true"
              aria-relevant="text"
            >
              <Truncate lines={1} ellipsis="...">
                {career.titleEn}
              </Truncate>
            </p>
          ) : (
            <p className="career-title-results">
              <Truncate lines={1} ellipsis="...">
                {career.titleEn}
              </Truncate>
            </p>
          )}

          <div className="subtext-info-icon-container">
            {renderSubTextAndInfoIcon()}
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  const userProfileId = state.admin.userProfileInfo?.id;
  const userProfileTenantId = state.admin.userProfileInfo?.tenantId;

  return { userProfileId, userProfileTenantId };
};

export default withRouter(
  connect(mapStateToProps)(withStyles(cardStyles)(GenericCareerCard))
);
